import { Footer } from './Footer';
import { Navigation } from './Navigation';

interface PublicLayoutProps {
  children: React.ReactNode;
  hideFooter?: boolean;
}

export function PublicLayout({ children, hideFooter = false }: PublicLayoutProps) {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navigation />
      <main className="flex-grow">{children}</main>
      {hideFooter ? null : <Footer />}
    </div>
  );
}
